export default {
  hideCompletedEventList: 'Abgeschlossene Ereignisse ausblenden',
};
